import { jarallax, jarallaxVideo } from "jarallax";

jarallaxVideo();

export default {
    init: function () {
        document.querySelectorAll(".jarallax").forEach((node) => {
            let options = JSON.parse(node.dataset.jarallaxOptions || "");

            if (options.disableMobile) {
                options.disableMobile = /iPad|iPhone|iPod|Android/;
            }

            jarallax(node, options);
        });

        jarallax(document.querySelectorAll(".jarallax"), {
            onDestroy: function () {

            }
        });
    },
    cleanup: function () {
        jarallax(document.querySelectorAll(".jarallax"), "destroy");
    }
};
